import { render } from "./ScreenLoader.vue?vue&type=template&id=5780bf60&scoped=true"
import script from "./ScreenLoader.vue?vue&type=script&lang=js"
export * from "./ScreenLoader.vue?vue&type=script&lang=js"

import "./ScreenLoader.vue?vue&type=style&index=0&id=5780bf60&scoped=true&lang=css"

import exportComponent from "/home/ad5hitotsuki/hitotsuki.net/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5780bf60"]])

export default __exports__